// React for Website

import React from "react";
//outsource
import { Col, Select, Form } from "antd";

//components
const refineData = (data) => {
  const newData = data?.map((item) => {
    const value = item?.id;
    const label = `${item?.name} | ${item?.shopId}`;

    return {
      value,
      label,
    };
  });

  return newData;
};

const VoucherName = ({ branches, setShop, disabled }) => {
  // -------------------------- VAR --------------------------
  
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION -----------------------
  const onChange = (value) => {
    const shop = branches?.find((item) => item?.id === value);
    setShop(shop);
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  const converted = refineData(branches);
  return (
    <Form.Item
      name="name"
      label="Created For"
      rules={[{ require: true, message: "Please select the name" }]}
    >
      <Select
        options={converted}
        showArrow
        placeholder="Please fill marketing Code"
        onChange={onChange}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default VoucherName;
